import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LookUpAPI, UserAPI } from '../constants/api.constants';
import { ResponseModel } from '../data/models/ResponseModel';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  constructor(private http: HttpClient) { }

  getAllCountries(countryName: string): Observable<ResponseModel> {
    return this.http.get<any>(LookUpAPI.GET_ALL_COUNTRIES_API, {
      params: { countryName: countryName }
    });
  }

  getAllStates(payload: any): Observable<ResponseModel> {
    return this.http.post<any>(LookUpAPI.GET_ALL_STATES_API, payload);
  }

  getAllCities(payload: any): Observable<any> {
    return this.http.post<any>(LookUpAPI.GET_ALL_CITIES_API, payload);
  }

  changeLanguage(payload: any): Observable<any> {
    return this.http.post<any>(UserAPI.UPDATE_LANGUAGE_API, payload);
  }
}
